import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL + 'v1/settings';

class SettingsService {
    /**
     * Wysyła żądanie zmiany adresu e-mail dla użytkownika.
     *
     * @param {Object} data - Obiekt zawierający starego i nowego e-maila użytkownika.
     * @param {string} data.oldEmail - Stary adres e-mail.
     * @param {string} data.newEmail - Nowy adres e-mail.
     * @return {Promise<Object>} - Zwraca obiekt z odpowiedzią serwera w przypadku sukcesu.
     * @throws {Object} - Zwraca błąd w przypadku niepowodzenia.
     */
    requestEmailChange(data) {
        return axios.put(`${API_URL}/request-change-email`, data)
        .then(response => response.data)
        .catch(error => {
            throw error.response.data;
        });
    }
  
    /**
     * Zmienia hasło użytkownika.
     *
     * @param {Object} data - Obiekt zawierający adres e-mail, stare hasło i nowe hasło użytkownika.
     * @param {string} data.uid - Id użytkownika.
     * @param {string} data.oldPassword - Stare hasło użytkownika.
     * @param {string} data.newPassword - Nowe hasło użytkownika.
     * @return {Promise<Object>} - Zwraca obiekt z odpowiedzią serwera w przypadku sukcesu.
     * @throws {Object} - Zwraca błąd w przypadku niepowodzenia.
     */
    changePassword(data) {
        return axios.put(`${API_URL}/change-password/${data.uid}`, data)
        .then(response => response.data)
        .catch(error => {
            throw error.response.data;
        });
    }

    async adminChangePassword(userId, newPassword) {
        return await axios.put(`${API_URL}/admin/change-password/${userId}`, { newPassword });
    }
  
    /**
     * Włącza lub wyłącza weryfikację dwuetapową (2FA) dla użytkownika.
     *
     * @param {Object} data - Obiekt zawierający informacje o użytkowniku, który zmienia ustawienia 2FA.
     * @param {string} data.email - Adres e-mail użytkownika.
     * @param {boolean} data.enabled - Flaga wskazująca, czy weryfikacja 2FA jest włączona (true) lub wyłączona (false).
     * @return {Promise<Object>} - Zwraca obiekt z odpowiedzią serwera w przypadku sukcesu.
     * @throws {Object} - Zwraca błąd w przypadku niepowodzenia.
     */
    toggleTwoFactorAuthentication(data) {
        return axios.post(`${API_URL}/toggle-2fa/${data.uid}`, null, {
          params: { enabled: data.enabled },
        })
          .then(response => response.data)
          .catch(error => {
            throw error.response.data;
          });
    }
}

export default new SettingsService();
